module.exports = __webpack_public_path__ + "img/MES6Indice4_cutout.5d696b30.png";